import { createMiddlewareStore } from '../createMiddlewareStore'
import { accessTokenRequest } from './accessToken'
import { clientScenarioRequest } from './clientScenario'
import { csrfTokenRequest, csrfTokenResponse } from './csrfToken'
import { ensureHeadersRequest } from './ensureHeader'
import { flowTokenRequest } from './flowToken'
import { jsonSerializeRequest, jsonSerializeResponse } from './jsonSerialize'
import { rejectOnErrorResponse } from './rejectOnError'
import { requestContextRequest, requestContextResponse } from './requestContext'
import { signatureRequest } from './signature'
import { CashRequest, CashRequestContext, CashResponse, CashResponseContext } from './types'

export const fetchRequestMiddleware = createMiddlewareStore<CashRequest, CashRequestContext>(
  ensureHeadersRequest,
  accessTokenRequest,
  csrfTokenRequest,
  clientScenarioRequest,
  flowTokenRequest,
  requestContextRequest,
  jsonSerializeRequest,
  signatureRequest
)
export const fetchResponseMiddleware = createMiddlewareStore<CashResponse, CashResponseContext>(
  csrfTokenResponse,
  rejectOnErrorResponse,
  jsonSerializeResponse,
  requestContextResponse
)
